import { useNavigate } from 'react-router-dom';

const references = [
  { name: 'ICF House', industry: 'Reality' },
  { name: 'Boxy Nosiče', industry: 'E-commerce' },
  { name: 'Salón Sirka', industry: 'Beauty' },
  { name: 'MUDr. Sivák', industry: 'Zdravotníctvo' },
  { name: 'Peter Motýľ', industry: 'Osobná značka' },
  { name: 'Meridia', industry: 'Poradenstvo' },
];

export default function AboutCTA() {
  const navigate = useNavigate();

  return (
    <section className="bg-zinc-900/30 border-t border-zinc-800/50 py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Social proof bar */}
        <div className="mb-20">
          <p className="text-center text-zinc-600 text-xs uppercase tracking-widest mb-8">Dôverujú mi</p>
          <div className="flex flex-wrap justify-center gap-4">
            {references.map((r) => (
              <div
                key={r.name}
                className="bg-zinc-900/60 border border-zinc-800/50 rounded-xl px-5 py-3 flex items-center gap-3"
              >
                <div className="w-2 h-2 flex items-center justify-center">
                  <div className="w-1.5 h-1.5 rounded-full bg-orange-400" />
                </div>
                <div>
                  <p className="text-white text-sm font-semibold leading-none">{r.name}</p>
                  <p className="text-zinc-600 text-xs mt-0.5">{r.industry}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Main CTA box */}
        <div className="relative overflow-hidden bg-gradient-to-br from-zinc-900 to-zinc-900/80 border border-zinc-800/60 rounded-3xl px-8 md:px-14 py-14 text-center">
          {/* bg glow */}
          <div
            className="absolute -top-20 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full pointer-events-none"
            style={{ background: 'radial-gradient(circle, rgba(249,115,22,0.12) 0%, transparent 65%)' }}
          />

          <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-4 relative z-10">
            Poďme spolupracovať
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-6 relative z-10">
            Pripravení začať?<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
              Prvá konzultácia je zadarmo.
            </span>
          </h2>
          <p className="text-zinc-400 text-base max-w-xl mx-auto mb-10 leading-relaxed relative z-10">
            Porozprávame sa o tvojom projekte bez záväzkov. Poviem ti, čo dáva zmysel - aj keď to znamená, že odo mňa nič nekúpiš.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center relative z-10">
            <button
              onClick={() => {
                navigate('/');
                setTimeout(() => {
                  const el = document.querySelector('#kontakt');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 300);
              }}
              className="group inline-flex items-center justify-center gap-2.5 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-400 hover:to-amber-400 text-white font-bold px-8 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              Nezáväzná konzultácia
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </button>
            <a
              href="mailto:info@boostio.sk"
              className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-zinc-500 text-zinc-300 hover:text-white font-medium px-8 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base bg-zinc-900/50"
            >
              <i className="ri-mail-line" />
              info@boostio.sk
            </a>
          </div>

          {/* Trust indicators */}
          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 relative z-10">
            {[
              { icon: 'ri-time-line', text: 'Odpoveď do 24 hodín' },
              { icon: 'ri-shield-check-line', text: 'Bez záväzkov' },
              { icon: 'ri-map-pin-line', text: 'Pracujem zo Slovenska' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 text-zinc-500 text-sm">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-orange-400 text-sm`} />
                </div>
                <span>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
